<template>
    <div class="app-container">
        <!-- Background stars image -->
        <div class="background-stars">
            <img src="./Images/background_stars.jpg" alt="Background Stars" class="stars-image" />
        </div>
        
        <!-- Gradient overlay on stars -->
        <div class="stars-gradient-overlay"></div>
        
        <!-- Lens flare effect -->
        <div class="lens-flare">
            <img src="./Images/lens_flare.jpg" alt="Lens Flare" class="flare-image" />
        </div>
        
        <!-- Blue overlay at top -->
        <div class="blue-overlay"></div>
        
        <!-- Content -->
        <div class="content">
            <div class="marg">
                <!-- Logo Component -->
                <div class="logo-container" :class="{ mobile: isMobile }">
                    <LogoComponent :isMobile="isMobile" />
                </div>
                
                <!-- Desktop-only text below logo -->
                <div v-if="!isMobile" class="desktop-text">
                    <p>Get our app now on Play Store!</p>
                </div>
                <div v-else class="mobile-text">
                    <p>Haven’t installed our app yet? <br>Get started!</p>
                </div>
                
                <div v-if="activeLink">
                    <a :href="activeLink" class="set wrapper">
                        <button class="blue-button footer">
                            <span class="buttonText">{{ buttonText }}</span>
                        </button>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Quicksand&display=swap');
* {
    font-family: 'Quicksand', sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body, html {
    margin: 0;
    padding: 0;
    height: 100%;
    overflow: hidden;
}

.app-container {
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: linear-gradient(0deg, #13102B, #13102B),
                linear-gradient(360deg, #13102B 0%, #27205C 100%);
    margin: 0;
    padding: 0;
}

/* Background stars image */
.background-stars {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
}

.stars-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.stars-gradient-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(360deg, #13102B 0%, #27205C 100%);
    z-index: 0;
    pointer-events: none;
    opacity: 0.7;
}

.blue-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 40%;
    background: linear-gradient(180deg, rgba(41, 107, 181, 0.3) 0%, rgba(41, 107, 181, 0.1) 50%, transparent 100%);
    z-index: 1;
    pointer-events: none;
}

.lens-flare {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
    opacity: 0.15;
    display: flex;
    align-items: center;
    justify-content: center;
}

.flare-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: blur(2px);
}

.content {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.set{
  text-decoration: none;
}

.logo-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
    z-index: 3;
}

.logo-container.mobile {
  margin-bottom: 0;
  margin-left: 0;
}

.desktop-text {
    text-align: center;
    margin-bottom: 2rem;
    margin-left: 2rem;
}
.mobile-text {
    text-align: center;
    margin-bottom: 2rem;
    padding-bottom: 2rem;
}

.desktop-text p {
    color: white;
    font-size: 32px;
    font-weight: 600;
    margin: 0;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
.mobile-text p {
    color: white;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
h1 {
 margin-bottom: 7vh;
  font-size: 30px;
font-weight: 600;
line-height: 32px;
letter-spacing: 0em;
}
p {
    
    font-size: 22px;
font-weight: 600;
line-height: 26px;
letter-spacing: 0em;
}
.wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
}
.blue-button {
    width: 280px;
    background: linear-gradient(135deg, #8B5CF6 0%, #A855F7 50%, #C084FC 100%);
    color: white;
    padding: 6px 20px;
    font-size: 16px;
    font-weight: 700;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 8px 25px rgba(139, 92, 246, 0.4);
    text-transform: none;
    letter-spacing: 0.5px;
    position: relative;
    overflow: hidden;
}

.blue-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
}

.blue-button:hover::before {
    left: 100%;
}

.blue-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 35px rgba(139, 92, 246, 0.6);
    background: linear-gradient(135deg, #7C3AED 0%, #9333EA 50%, #A855F7 100%);
}

.blue-button:active {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(139, 92, 246, 0.5);
}
.buttonText {
    font-family: 'Quicksand', sans-serif;
    font-weight: 700;
    position: relative;
    z-index: 1;
    line-height: 1.5;
}    
.footer {
 bottom: 5vh;
display: block;
 
}
.marg{
  padding: 15px;
}
    
</style>



<script>
import LogoComponent from './LogoComponent.vue';

export default {
name: 'DownloadApp',
components: {
  LogoComponent
},

  data() {
    return {
      buttonText: "Download Now",
        osFound:null,
        activeLink: null,
        windowWidth: window.innerWidth
    };
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
    this.getOS()
    const url = new URL(window.location.href);
    const refVal = url.search;
    console.log(window.innerWidth > 600, refVal.includes('ref'));
    if (refVal.includes('ref') && (window.innerWidth > 600)) {
      window.location.assign(`https://web.imeuswe.in/${refVal}`);
      history.replaceState({}, '', `${url.origin}`);
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 768; // Mobile threshold at 768px
    }
  },
  methods:{
    getOS() {
  let userAgent = window.navigator.userAgent,
      platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
      // macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      // windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod']
      
   if (iosPlatforms.indexOf(platform) !== -1) {
    this.osFound = 'iOS';
    this.activeLink = "itms-apps://itunes.apple.com/app/id1634383924"
  } else if (/Android/.test(userAgent)) {
    this.osFound = 'Android';
    this.activeLink = "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.imeuswe.app"
  } else {
    console.error('no os')
  }
}
  }
  
};
</script>